import { useLocalStorage } from '@mantine/hooks';

type Mode = 'desktop' | 'terminal';
export const useMode = () => {
  return useLocalStorage<Mode>({
    key: 'mode',
    defaultValue: 'desktop',
  });
};
